export default __webpack_public_path__ + "static/media/youtube.30e8d286.svg";